var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChangeIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28279_89772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.275 14.52L16.525 11.395C16.3387 11.2388 16.0787 11.2075 15.86 11.3088C15.64 11.4125 15.5 11.6325 15.5 11.875V13.75H14.4538C13.5863 13.75 12.7937 13.31 12.3337 12.575L8.28625 6.1C7.3675 4.62875 5.7825 3.75 4.04625 3.75H0.5V6.25H4.04625C4.91375 6.25 5.70625 6.69 6.16625 7.425L10.2137 13.9C11.1337 15.3713 12.7188 16.25 14.4538 16.25H15.5V18.125C15.5 18.3675 15.64 18.5875 15.86 18.6912C15.9438 18.73 16.035 18.75 16.125 18.75C16.2688 18.75 16.4112 18.7013 16.525 18.605L20.275 15.48C20.4187 15.3612 20.5 15.185 20.5 15C20.5 14.815 20.4187 14.6388 20.275 14.52Z",
    fill: "#329EF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.275 4.51907L16.525 1.39407C16.3388 1.23907 16.0788 1.20657 15.86 1.30907C15.64 1.41032 15.5 1.63157 15.5 1.87407V3.74907H14.4538C12.7175 3.74907 11.1325 4.62782 10.2138 6.09907L9.9875 6.46157L11.4613 8.82032L12.3338 7.42407C12.7938 6.68907 13.5863 6.24907 14.4538 6.24907H15.5V8.12407C15.5 8.36657 15.64 8.58782 15.86 8.69032C15.9438 8.72907 16.035 8.74907 16.125 8.74907C16.2688 8.74907 16.4113 8.69907 16.525 8.60407L20.275 5.47907C20.4188 5.36032 20.5 5.18407 20.5 4.99907C20.5 4.81407 20.4188 4.63782 20.275 4.51907Z",
    fill: "#329EF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03875 11.1797L6.1675 12.5759C5.7075 13.3109 4.91375 13.7509 4.04625 13.7509H0.5V16.2509H4.04625C5.78125 16.2509 7.36625 15.3722 8.28625 13.9009L8.5125 13.5384L7.03875 11.1797Z",
    fill: "#329EF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28279_89772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChangeIcon);
export default ForwardRef;